<script>
import { mapActions, mapState } from 'vuex';

import LogoHeader from '@/components/onboarding/logo-header.vue';
import store from '../../store';
import { registerSegmentAnalytics } from '../../helpers/segment';

export default {
  name: 'TrialExplainer',
  components: {
    LogoHeader,
  },
  computed: {
    ...mapState({
      loading: (state) => state.checkout.loading,
      onboarding: (state) => state.onboarding,
      showOnboarding: (state) => state.login.showOnboarding,
    }),
  },
  watch: {
    showOnboarding(newValue) {
      if (!newValue) {
        this.$router.replace({ name: '/' });
      }
    },
  },
  methods: {
    ...mapActions(['checkoutTieredPricing']),
    handleContinue() {
      this.checkoutTieredPricing({ priceId: 'trial', interval: 'monthly', trial: true });
    },
  },
  mounted() {
    // eslint-disable-next-line
    const { id, userName, email, name: teamName } = store.state.login;
    registerSegmentAnalytics({
      user_id: id,
      email,
      userName,
      teamName,
    });
  },
};
</script>

<template>
  <div id="main-container" class="container-fluid">
    <div class="row inner-container">
      <div class="col-6 panel">
        <logo-header />
        <div class="row">
          <div class="my-5 text-center">
            <h3 class="my-4">Start your 30-day FREE trial to continue.</h3>

            <h4 class="text-muted my-5">
              You can cancel your plan anytime, you will only be charged
              <strong><u>if you have more than 24 Slack members</u></strong>
            </h4>

            <b-button :disabled="loading" block variant="primary" size="lg" @click="handleContinue"
              >Start my 30-day free trial</b-button
            >
            <h6 class="text-muted my-3">
              No payment due now — enjoy 30 days free, then just $29/mo.
            </h6>
            <div class="mt-5">
              <h1 class="used-by-text">Used by 600+ happy teams!</h1>
              <img
                src="@/assets/team-logos.png"
                alt="Remote Teams"
                fluid
                width="100%"
                class="mt-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 panel light-blue">
        <b-progress :value="80" class="progress-container" />
        <div class="text-center mt-5">
          <img src="@/assets/onboarding-5.png" alt="Remote Teams" fluid width="100%" class="mt-5" />
        </div>
        <div class="card mt-5">
          <div class="card-body">✅ The best value option for Slack</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#main-container .inner-container {
  min-height: 100vh;
}

.inner-container .panel {
  padding: 70px;
}

.inner-container .light-blue {
  background-color: #f4f7fc;
}

.used-by-text {
  color: #222e3f;
  font-weight: 600;
  line-height: 140%;
  font-size: 34px;
  font-style: italic;
}
</style>
